import logoImg from "assets/images/logo.svg"
import profileImg from "assets/images/profile-img.svg"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { userAccountParameters } from "helpers/requests"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import SweetAlert from "react-bootstrap-sweetalert"
import { Link, useParams } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import vomozLogo from "../../assets/images/vomoz/ball.png"
import Main from "./components/Main/Main"
import Search from "./components/SearchLocation/SearchLocation"
import "./styles.scss"

const user = JSON.parse(localStorage.getItem("userData")) || {}

const BecomeAPartner = () => {
  const [loading, setLoading] = useState(null)
  const [load, setLoad] = useState(null)
  const [userFirstName, setUserFirstName] = useState(null)
  const [userLastName, setUserLastName] = useState(null)
  const [userEmail, setUserEmail] = useState(null)
  const params = useParams()

  console.log(params)
  const getUserAccountParameters = async () => {
    setLoading(true)
    const data = {
      orgId: "939001",
      userGlobalId: user?.userGlobalId,
    }
    const parameters = await userAccountParameters(data)
    const userParameters = parameters?.data
    if (userParameters) {
      setLoading(false)
      setUserFirstName(userParameters.firstName)
      setUserLastName(userParameters.lastName)
      setUserEmail(userParameters.email)
      setLoad(true)
    }
  }

  useEffect(() => {
    getUserAccountParameters()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        {loading && (
          <SweetAlert
            title="Loading"
            timeout={2000}
            showConfirm={false}
            onConfirm={() => setLoading(null)}
          >
            <img className="spinning loading-logo" src={vomozLogo} />
          </SweetAlert>
        )}
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Services"} breadcrumbItem={"Rates"} />
          <Row className="justify-content-center">
            <Col lg={9}>
              <Card className="overflow-hidden">
                <div className="bg-soft-primary">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h4 className="text-primary">Worldwide Coverage</h4>
                        <p>
                          VomozFlex is the easiest means to reach out. Search
                          for our different rates to connect anywhere in the
                          world.
                        </p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profileImg} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logoImg}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Search />
                    <div style={{ marginTop: "20px" }}>
                      {params.country && <Main />}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

BecomeAPartner.propTypes = {
  t: PropTypes.any,
}

export default BecomeAPartner
